'use client';

import React, { useId, useState } from 'react';
import { cn } from '@/helpers/common';
import { HOMEPAGE_QUESTIONS } from '@/constants/kg/default';

const HomepageQuestionsKG = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const idPrefix = useId();

  return (
    <div className="bg-white w-full border-y border-kg-athens-gray">
      <div className="container px-4 py-15 w-full">
        <p className="text-sm text-center mx-auto font-bold text-kg-fun-blue tracking-wider">
          <span aria-hidden="true">{'>'}</span> COMMON QUESTIONS
        </p>
        <h2 className="mt-5 mx-auto font-bold max-md:text-3xl md:text-4xl text-kg-black-pearl text-center tracking-tighter">
          Before you ask the robot
        </h2>
        <div className="mt-8 max-w-200 mx-auto flex flex-col rounded-xs border border-kg-athens-gray divide-y divide-kg-athens-gray bg-white">
          {HOMEPAGE_QUESTIONS.map((question, index) => {
            const isOpen = openIndex === index;
            const panelId = `${idPrefix}-${index}`;

            return (
              <div key={question.title}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="group flex w-full items-center gap-3 p-4 text-left"
                >
                  <span
                    className="w-4 shrink-0 font-bold text-kg-fun-blue text-sm"
                    aria-hidden="true"
                  >
                    ?
                  </span>
                  <span
                    className={cn(
                      'flex-1 font-bold text-sm default-transition group-hover:text-kg-fun-blue',
                      isOpen ? 'text-kg-fun-blue' : 'text-kg-black-pearl',
                    )}
                  >
                    {question.title}
                  </span>
                  <span
                    className={cn(
                      'shrink-0 text-lg text-kg-fun-blue leading-5 default-transition',
                      isOpen && 'rotate-90',
                    )}
                    aria-hidden="true"
                  >
                    {'>'}
                  </span>
                </button>
                <p id={panelId} hidden={!isOpen} className="pb-4 pl-11 pr-4 text-sm text-kg-mako">
                  {question.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HomepageQuestionsKG;
